import {useState} from 'react';
import injectSheet from 'react-jss';
import qs from 'query-string';

import greetingStyles from '-/styles/sections/greeting';
import {ControlGroup, Control} from '-/components/fields/Control';
import CreditorService from '-/services/CreditorService';
import Select from '-/components/fields/Select';
import Legend from '-/components/fields/Legend';
import {renderFieldErrors} from '-/util/util';

const styles = theme => ({
    ...greetingStyles(theme),
    landingcards: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: 30,
        '& div': {
            '&:hover': {
                backgroundColor: 'palegreen'
            },
            cursor: 'pointer',
            flex: 1,
            margin: 10,
            backgroundColor: '#dadada',
            border: 'solid 2px #ccc',
            borderRadius: 3,
            '& i': {
                display: 'block',
                fontSize: 80,
                marginTop: 20
            },
            '& span': {
                display: 'block',
                marginTop: 20,
                fontSize: 40,
                padding: 10,
                fontWeight: 'bold',
                backgroundColor: '#fafafa',
                borderTop: 'solid 2px #ccc'
            }
        }
    }
});

const NewOffer = props => {
    const [errors, setErrors] = useState([]);
    const [selectedSalesperson, setSelectedSalesperson] = useState(null);
    const {classes = {}} = props;
    const salespeople = CreditorService.getSalespeople() || [];
    const onOptionClick = type => {
        const {t, ...rest} = qs.parse(location.search);
        const params = qs.stringify(rest);
        
        window.location.href = `/?offerId=${type}&${params}`;
    };

    const onSalespersonChange = value => {
        const selected = salespeople.find(person => person.dmsId === value);

        if (selected) {
            const {dmsId} = selected;
            
            setSelectedSalesperson(dmsId);

            localStorage.setItem('salesperson', dmsId);
        }
    };

    return (
        <section className={classes.root}>
            <h1>Let&apos;s Get Started!</h1>
            <p>How would you like to purchase your vehicle?</p>
            <div className={classes.landingcards}>
                <div onClick={onOptionClick.bind(null, 'cash')}>
                    <i className="fa fa-money" />
                    <span>Pay Cash</span>
                </div>
                <div onClick={onOptionClick.bind(null, 'finance')}>
                    <i className="fa fa-credit-card" />
                    <span>Finance</span>
                </div>
            </div>
            {errors.length > 0 ? renderFieldErrors(errors) : null}
            {Array.isArray(salespeople) && salespeople.length > 0 && (
                <div style={{textAlign: 'left', padding: '0px 40px'}}>
                    <ControlGroup>
                        <Legend>Select Salesperson</Legend>
                        <Control>
                            <Select onChange={onSalespersonChange}>
                                <option value=""></option>
                                {salespeople.map((person, i) => {
                                    const {dmsId, fullName} = person;
                                    const selected = dmsId === selectedSalesperson;

                                    return (
                                        <option key={`salesperson-${i}`} value={dmsId} selected={selected}>{fullName}</option>
                                    );
                                })}
                            </Select>
                        </Control>
                    </ControlGroup>
                </div>
            )}
        </section>
    );
};

export default injectSheet(styles)(NewOffer);
